import { FormControl, FormLabel, MenuItem, Select } from '@mui/material';
import { useEffect } from 'react';

import { EmptySelect } from '@/components/regions/emptySelect';
import { useDAL } from '@/contexts/useDAL';

const title = 'Machine type*';

export const GcpMachineTypeSelect = ({
  machineType,
  onChange,
  accountId,
  zone,
}: {
  machineType?: string;
  onChange: (machineType?: string, isUserChange?: boolean) => void;
  accountId?: string;
  zone?: string;
}) => {
  if (!accountId || !zone) {
    return <EmptySelect title={title} />;
  }

  return (
    <InnerGcpMachineTypeSelect
      machineType={machineType}
      onChange={onChange}
      accountId={accountId}
      zone={zone}
    />
  );
};

const InnerGcpMachineTypeSelect = ({
  machineType,
  onChange,
  accountId,
  zone,
}: {
  machineType?: string;
  onChange: (machineType?: string, isUserChange?: boolean) => void;
  accountId: string;
  zone: string;
}) => {
  const dal = useDAL();
  const { data: body, isLoading } = dal.restore.gcpVm.listMachineTypes(
    accountId,
    zone
  );

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (machineType && !body?.machineTypes?.includes(machineType)) {
      onChange(undefined);
    }
  }, [body?.machineTypes, isLoading, onChange, machineType]);

  if (!body?.machineTypes?.length) {
    return <EmptySelect title={title} />;
  }

  return (
    <FormControl size='small' className='flex-1'>
      <FormLabel>{title}</FormLabel>
      <Select
        size='small'
        value={machineType || ''}
        onChange={(event) => onChange(event.target.value)}
      >
        {body.machineTypes.map((machineType) => (
          <MenuItem key={machineType} value={machineType}>
            {machineType}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
